export const capitalizeWords = (str) => str.replace(/\b\w/g, (char) => char.toUpperCase());

export const pkr = (n, jsx = true) => {
    // const checkNum = String(n ?? "").replaceAll(",", "");

    // if (!checkNum || isNaN(Number(checkNum))) return "—";

    // const num = Number(checkNum).toLocaleString("en-PK");

    // if (!jsx) return `₨ ${num}`;

    // return (
    //     <>
    //         <span className="text-[0.8em] pr-1 opacity-70 inline-block">₨</span>
    //         <span>{num}</span>
    //     </>
    // );

    return (
        money(n, { symbol: "₨", locale: "en-PK", compact: false, jsx: jsx })
    )
};

export const usd = (n, jsx = true) => {
    // const checkNum = String(n ?? "").replaceAll(",", "");

    // if (!checkNum || isNaN(Number(checkNum))) return "—";

    // const num = Number(checkNum).toLocaleString("en", {
    //     maximumFractionDigits: 0
    // });

    // if (!jsx) return `$ ${num}`;

    // return (
    //     <>
    //         <span className="text-[0.8em] pr-1 opacity-70 inline-block">$</span>
    //         <span>{num}</span>
    //     </>
    // );
    return (
        money(n, { symbol: "$", locale: "en", compact: false, jsx: jsx })
    )
};

export const money = (
    n,
    {
        symbol = "₨",
        locale = "en-PK",
        compact = false,
        jsx = true,
    } = {}
) => {
    const checkNum = String(n ?? "").replaceAll(",", "");

    if (!checkNum || isNaN(Number(checkNum))) return "—";

    const num = Number(checkNum);

    const fmt = (v) => {
        const a = Math.abs(v);

        if (compact) {
            if (a >= 1e9) return (v / 1e9).toFixed(1).replace(".0", "") + "B";
            if (a >= 1e6) return (v / 1e6).toFixed(1).replace(".0", "") + "M";
            if (a >= 1e3) return (v / 1e3).toFixed(0) + "K";
        }

        return v.toLocaleString(locale);
    };

    const value = fmt(num);

    if (!jsx) return `${symbol} ${value}`;

    return (
        <>
            <span className="text-[0.8em] pr-1 opacity-70 inline-block">{symbol}</span>
            <span>{value}</span>
        </>
    );
};

export const fmt = n => { const a = Math.abs(n); return a >= 1e6 ? (n / 1e6).toFixed(1) + "M" : a >= 1000 ? (n / 1000).toFixed(0) + "K" : Number(n).toLocaleString(); };